// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {liteTemplate} from "@/lib/routes";
import {getMainParentRouteName} from "@/lib/lib";

const defaultSetRoute = {
    geoitems: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozone', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.main,
            params: {},
            query: {...route.query},
        })
    },
    geozone: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozone', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.geozones.main,
            params: {},
            query: {...route.query},
        })
    },
    geozoneId: (route, router, geozoneId, groupId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozoneId', route);
            return false
        }
        if(!groupId) groupId = 0;
        router.push({
            name: consts.routerNames.geoitems.geozones.group.geozoneId,
            params: {
                groupId,
                geozoneId,
            },
            query: {...route.query},
        })
    },
    geozoneEdit: (route, router, geozoneId, groupId= 0) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozoneEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.geozones.group.geozoneEdit,
            params: {
                geozoneId,
                groupId,
            },
            query: {...route.query},
        })
    },
    geozoneFilter: (route, router, filter) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.geoitems.main) {
            if (consts.app.$isDevelopment) console.warn('geozoneFilter', route);
            return false
        }
        router.push({
            name: route.name,
            params: {
                ...route.params
            },
            query: {...filter}
        })
    },
    addGeozoneGroupEdit: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('addGeozoneGroupEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.edit.editPopup,
            params: {
            },
            query: {...route.query},
        })
    },
    geozoneGroupId: (route, router, groupId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozoneId', route);
            return false
        }
        if(!groupId) groupId = 0;
        router.push({
            name: consts.routerNames.geoitems.geozones.group.id,
            params: {
                groupId,
            },
            query: {...route.query},
        })
    },
    geozoneGroupEdit: (route, router, groupId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozoneEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.geozones.group.edit,
            params: {
                groupId,
            },
            query: {...route.query},
        })
    },
    returnToParent:(route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.geoitems.main+' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.geoitems.main;
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query: {...route.query}
        })
    },
    liteTemplate,
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'geoitems/:pathMatch(.*)?/:noList(no-list)?',
        name: consts.routerNames.geoitems.main,
        meta: {
            list: 'GeoitemsList',
            mainRouteName: consts.routerNames.geoitems.main,
            showMap: true,
            isLimited: false,
            layers: {
                ...consts.defaultSettingsLayers,
                geoitems: {visible: true, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        component:() => import('@/views/prometheus/portal/GeoitemsPage.vue'),
        children: [
            {
                path: 'geozones',
                name: consts.routerNames.geoitems.geozones.main,
                meta:{
                    mainRouteName: consts.routerNames.geoitems.main,
                    parentRouteName: consts.routerNames.geoitems.main,
                    layers: {
                        ...consts.defaultSettingsLayers,
                        units: {visible: false, showInList: true, showLayer: true},
                        geoitems: {visible: true, showInList: true, showLayer: true},
                        geoitem_edit: {visible: true, showInList: false, showLayer: true},
                    }
                },
                children: [
                    {
                        path: ':groupId(\\d+)',
                        name: consts.routerNames.geoitems.geozones.group.id,
                        meta:{
                            mainRouteName: consts.routerNames.geoitems.main,
                            parentRouteName: consts.routerNames.geoitems.geozones.main,
                        },
                        children: [
                            {
                                path: 'edit',
                                name: consts.routerNames.geoitems.geozones.group.edit,
                                meta: {
                                    mainRouteName: consts.routerNames.geoitems.main,
                                    parentRouteName: consts.routerNames.geoitems.geozones.group.id,
                                    blockingRoutesTransitionFromOutside: true,
                                    sectionInfoByRoute: true,
                                },
                                props: {
                                    sectionInfoByRoute: (route) => ({
                                        geozoneGroupId: +route.params.groupId,
                                        time: Date.now(),
                                    })
                                },
                                components: {
                                    sectionInfoByRoute: () => import('@/components/geoitems/geozones-groups/sectionInfo/GeozoneGroupEdit.vue'),
                                }
                            },
                            {
                                path: ':geozoneId(\\d+)',
                                name: consts.routerNames.geoitems.geozones.group.geozoneId,
                                meta:{
                                    mainRouteName: consts.routerNames.geoitems.main,
                                    parentRouteName: consts.routerNames.geoitems.geozones.group.id,
                                },
                                children: [
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.geoitems.geozones.group.geozoneEdit,
                                        meta: {
                                            mainRouteName: consts.routerNames.geoitems.main,
                                            parentRouteName: consts.routerNames.geoitems.geozones.group.geozoneId,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                geozoneId: +route.params.geozoneId,
                                                time: 1,
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/GeozoneEdit.vue'),
                                        },
                                        children: [
                                            {
                                                path: 'group',
                                                name: consts.routerNames.geoitems.edit.editPopup,
                                                meta: {
                                                    mainRouteName: consts.routerNames.geoitems.main,
                                                    parentRouteName: consts.routerNames.geoitems.geozones.group.geozoneEdit,
                                                    blockingRoutesTransitionFromOutside: true,
                                                    sectionInfoByRoute: true,
                                                },
                                                props: {
                                                    geozoneEditGroup: () => ({
                                                        time: 1,
                                                    })
                                                },
                                                components: {
                                                    geozoneEditGroup: () => import('@/components/geoitems/geozones-groups/PopupGeozoneGroupEdit.vue'),
                                                },
                                                children: [

                                                ]
                                            },
                                        ]
                                    },
                                ]
                            },
                        ]
                    },
                ]
            },
            // {
            //     path: 'geopoints',
            //     name: consts.routerNames.geoitems.groups.main,
            //     meta:{
            //         mainRouteName: consts.routerNames.geoitems.main,
            //         parentRouteName: consts.routerNames.geoitems.main,
            //         layers: {
            //             ...consts.defaultSettingsLayers,
            //             units: {visible: false, showInList: true, showLayer: true},
            //             geoitems: {visible: false, showInList: true, showLayer: true},
            //             geoitem_edit: {visible: true, showInList: false, showLayer: true},
            //         }
            //     },
            //     children: [
            //         {
            //             path: 'groupId(\\d+)',
            //             name: consts.routerNames.geoitems.groups.main,
            //             meta:{
            //                 mainRouteName: consts.routerNames.geoitems.main,
            //                 parentRouteName: consts.routerNames.geoitems.main,
            //             },
            //             children: [
            //                 {
            //                     path: 'edit',
            //                     name: consts.routerNames.geoitems.groups.edit.main,
            //                     meta: {
            //                         mainRouteName: consts.routerNames.geoitems.main,
            //                         parentRouteName: consts.routerNames.geoitems.groups.main,
            //                         blockingRoutesTransitionFromOutside: true,
            //                         sectionInfoByRoute: true,
            //                     },
            //                     props: {
            //                         sectionInfoByRoute: (route) => ({
            //                             geozoneGroupId: +route.params.geozoneGroupId,
            //                             time: Date.now(),
            //                         })
            //                     },
            //                     components: {
            //                         sectionInfoByRoute: () => import('@/components/geoitems/geozones-groups/sectionInfo/GeozoneGroupEdit.vue'),
            //                     }
            //                 },
            //                 {
            //                     path: 'geoitemId(\\d+)',
            //                     name: consts.routerNames.geoitems.groups.main,
            //                     meta:{
            //                         mainRouteName: consts.routerNames.geoitems.main,
            //                         parentRouteName: consts.routerNames.geoitems.main,
            //                     },
            //                     children: [
            //                         {
            //                             path: 'edit',
            //                             name: consts.routerNames.geoitems.groups.edit.main,
            //                             meta: {
            //                                 mainRouteName: consts.routerNames.geoitems.main,
            //                                 parentRouteName: consts.routerNames.geoitems.groups.main,
            //                                 blockingRoutesTransitionFromOutside: true,
            //                                 sectionInfoByRoute: true,
            //                             },
            //                             props: {
            //                                 sectionInfoByRoute: (route) => ({
            //                                     geozoneGroupId: +route.params.geozoneGroupId,
            //                                     time: Date.now(),
            //                                 })
            //                             },
            //                             components: {
            //                                 sectionInfoByRoute: () => import('@/components/geoitems/geozones-groups/sectionInfo/GeozoneGroupEdit.vue'),
            //                             }
            //                         },
            //                     ]
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // {
            //     path: ':groupId(\\d+)',
            //     name: consts.routerNames.geoitems.groups.main,
            //     meta:{
            //         mainRouteName: consts.routerNames.geoitems.main,
            //         parentRouteName: consts.routerNames.geoitems.main,
            //     },
            //     children: [
            //         {
            //             path: 'edit',
            //             name: consts.routerNames.geoitems.groups.edit.main,
            //             meta: {
            //                 mainRouteName: consts.routerNames.geoitems.main,
            //                 parentRouteName: consts.routerNames.geoitems.groups.main,
            //                 blockingRoutesTransitionFromOutside: true,
            //                 sectionInfoByRoute: true,
            //                 layers: {
            //                     ...consts.defaultSettingsLayers,
            //                     units: {visible: false, showInList: true, showLayer: true},
            //                     geoitems: {visible: false, showInList: true, showLayer: true},
            //                     geoitem_edit: {visible: true, showInList: false, showLayer: true},
            //                 }
            //             },
            //             props: {
            //                 sectionInfoByRoute: (route) => ({
            //                     geozoneGroupId: +route.params.geozoneGroupId,
            //                     time: Date.now(),
            //                 })
            //             },
            //             components: {
            //                 sectionInfoByRoute: () => import('@/components/geoitems/geozones-groups/sectionInfo/GeozoneGroupEdit.vue'),
            //             }
            //         },
            //         {
            //             path: ':geozoneId(\\d+)',
            //             name: consts.routerNames.geoitems.id,
            //             meta:{
            //                 mainRouteName: consts.routerNames.geoitems.main,
            //                 parentRouteName: consts.routerNames.geoitems.groups.main,
            //             },
            //             children: [
            //                 {
            //                     path: 'edit',
            //                     name: consts.routerNames.geoitems.edit.main,
            //                     meta: {
            //                         mainRouteName: consts.routerNames.geoitems.main,
            //                         parentRouteName: consts.routerNames.geoitems.id,
            //                         blockingRoutesTransitionFromOutside: true,
            //                         sectionInfoByRoute: true,
            //                         layers: {
            //                             ...consts.defaultSettingsLayers,
            //                             units: {visible: false, showInList: true, showLayer: true},
            //                             geoitems: {visible: false, showInList: true, showLayer: true},
            //                             geoitem_edit: {visible: true, showInList: false, showLayer: true},
            //                         }
            //                     },
            //                     props: {
            //                         sectionInfoByRoute: (route) => ({
            //                             geozoneId: +route.params.geozoneId,
            //                             time: Date.now(),
            //                         })
            //                     },
            //                     components: {
            //                         sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/GeozoneEdit.vue'),
            //                     }
            //                 },
            //             ]
            //         },
            //     ]
            // },
        ],
    },
];

export default routes